import type { DBTeam } from '@core/types/types.db';

export function isEditor(team: DBTeam, userId: string) {
  // Admins automatically have editor permissions
  if (team.admins.includes(userId)) {
    return true;
  }

  return team.editors.includes(userId);
}

/**
 * Check if a user has admin permissions for a team
 */
export function isAdmin(team: DBTeam, userId: string) {
  // Check if user is explicitly in admins array
  return team.admins.includes(userId);
}
